export default {"src":"/_next/static/media/wordpress-service.2952b864.7a46a820.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};